import atoms from "../../../atoms"
import { ProductTypeFormProps } from "./interface"

const { Input } = atoms




const ProductTypeForm = ({ handleChange, productTypeValues, errors }: ProductTypeFormProps) => {
    return (
        <form>
            <div className="row">
                <div className="col-6">
                    <Input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Enter Product Type"
                        onChange={(e: any) => handleChange("name", e.target.value)}
                        defaultValue={productTypeValues.name}
                        label='Product Type Name'
                        errors={errors.name}
                    />
                </div>
                <div className="col-6">
                    <Input
                        type="text"
                        className="form-control"
                        id="arabicProductType"
                        placeholder="Enter Arabic Product Type"
                        onChange={(e: any) => handleChange("ar_name", e.target.value)}
                        defaultValue={productTypeValues.ar_name}
                        label='Product Arabic Type Name'
                        errors={errors.name}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-6 mt-25">
                    <Input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Example (S for Sunglass)"
                        onChange={(e: any) => handleChange("product_type_initials", e.target.value)}
                        defaultValue={productTypeValues.product_type_initials}
                        label='Product Type Initials'
                        errors={errors.product_type_initials}
                    />
                </div>
                <div className="col-6 mt-25">
                    <Input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Enter HSN Code"
                        onChange={(e: any) => handleChange("code", e.target.value)}
                        defaultValue={productTypeValues.code}
                        label='HSN Code (India)'
                        errors={errors.code}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-6 mt-25">
                    <Input
                        type="number"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="GST Percentage"
                        onChange={(e: any) => handleChange("percentage", e.target.value)}
                        defaultValue={productTypeValues.percentage}
                        label='GST Percentage (%) (India)'
                        errors={errors.percentage}
                    />
                </div>
                <div className="col-6 mt-25">
                    <Input
                        type="text"
                        className="form-control"
                        id="tax_code_01"
                        placeholder="Enter Tax Code"
                        onChange={(e: any) => handleChange("tax_code", e.target.value)}
                        defaultValue={productTypeValues.tax_code}
                        label='Tax Code (Kuwait)'
                        errors={errors.tax_code}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-6 mt-25">
                    <Input
                        type="number"
                        className="form-control"
                        id="tax_rate_01"
                        placeholder="Tax Rate"
                        onChange={(e: any) => handleChange("tax_rate", e.target.value)}
                        defaultValue={productTypeValues.tax_rate}
                        label='Tax Rate (%) (Kuwait)'
                        errors={errors.tax_rate}
                    />
                </div>
            </div>
        </form>
    )
}

export default ProductTypeForm